module.exports = __webpack_public_path__ + "img/loadingHardly.6b58b342.gif";